import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import BrandPageHeadTags from './head';
import { loadBrand } from './actions';
import { addCart, showCart } from 'components/cart/actions';
import BrowseMore from 'components/browseMore';
import Product from './Product';

let BrandPage = class BrandPage extends React.Component {
  constructor(props) {
    super(props);
    this.add = this.add.bind(this);
  }

  componentDidMount() {
    const prevSlug = this.props.slug;
    const nextSlug = this._slugFromRoute(this.props);
    if (nextSlug !== prevSlug) {
      this.props.loadBrand(nextSlug);
    }
  }

  componentDidUpdate(prevProps) {
    const prevSlug = this._slugFromRoute(prevProps);
    const nextSlug = this._slugFromRoute(this.props);
    if (nextSlug !== prevSlug) {
      this.props.loadBrand(nextSlug);
    }
  }

  _slugFromRoute(props) {
    const params = (props.match && props.match.params) || {};
    return decodeURIComponent(params.brandname);
  }

  add(product) {
    this.props.addCart(product, 1, { checkout: this.props.checkout });
    setTimeout(this.props.showCart, 500);
  }

  render() {
    const { loading, slug, brandname, header, footer, products } = this.props;

    return loading ? (
      <div className="row center-xs brand-page__loading-container banner-padding">
        <div className="col-xs-12">
          <Spinner spinnerName="three-bounce" />
        </div>
      </div>
    ) : (
      <div className="brand-page banner-padding">
        <BrandPageHeadTags brandname={brandname} slug={slug} />
        <Header content={header} brandname={brandname} />
        <div className="brand-page__container">
          <div className="row center-xs">
            {products.map(product => (
              <div key={product.sku_id} className="col-xs-6 col-sm-3">
                <Product product={product} add={() => this.add(product)} />
              </div>
            ))}
          </div>
        </div>
        <Footer content={footer} />
      </div>
    );
  }
};

BrandPage = connect(
  state => ({ ...state.brands }),
  {
    loadBrand,
    addCart,
    showCart
  }
)(BrandPage);

function Header(props) {
  return props.content ? (
    <div dangerouslySetInnerHTML={{ __html: props.content }} />
  ) : (
    <div className="brand-page__header">
      <div className="brand-page__heading-label">Shop</div>
      <h1 className="brand-page__heading">{props.brandname}</h1>
      <hr className="light" />
    </div>
  );
}

function Footer(props) {
  return props.content ? (
    <div dangerouslySetInnerHTML={{ __html: props.content }} />
  ) : (
    <div className="brand-page__footer">
      <BrowseMore
        headingText="Shop By Category"
        itemClassName="brand-page__footer-tile"
      />
    </div>
  );
}

export default BrandPage;
